import { render } from "./MemberTierProgress.vue?vue&type=template&id=cb0c664a&scoped=true"
import script from "./MemberTierProgress.vue?vue&type=script&lang=js"
export * from "./MemberTierProgress.vue?vue&type=script&lang=js"

import "./MemberTierProgress.vue?vue&type=style&index=0&id=cb0c664a&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb0c664a"]])

export default __exports__